import React from "react";

const Settings : React.FC = () => {
    return(
        <>
            Settings       
        </>
    )
}

export default Settings